import React, { useState, useEffect } from "react";
import { X } from "lucide-react";
import MobileHeader from "../../decision/Mobile/MobileHeader";
import "./MobileNavigation.css";

const MobileNavigation = ({
    onSearch,
    searchInput,
    setSearchInput,
    handleLogin,
    children
}) => {
    const [isMenuOpen, setIsMenuOpen] = useState(false);

    useEffect(() => {
        const handleResize = () => {
            if (window.innerWidth > 768) {
                setIsMenuOpen(false);
            }
        };

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const toggleMenu = () => {
        setIsMenuOpen(!isMenuOpen);
    };

    const closeMenu = () => {
        setIsMenuOpen(false);
    };

    return (
        <div className="mobile-navigation">
            {/* Utilisation du MobileHeader */}
            <MobileHeader
                searchInput={searchInput}
                setSearchInput={setSearchInput}
                handleSearch={onSearch}
                toggleMobileMenu={toggleMenu}
                handleLogin={handleLogin}
            />

            {/* Menu mobile */}
            {isMenuOpen && (
                <div className="mobile-menu-overlay">
                    <div className="mobile-menu">
                        <div className="mobile-menu-header">
                            <h2>Menu</h2>
                            <button className="mobile-menu-close" onClick={closeMenu}>
                                <X size={24} />
                            </button>
                        </div>

                        <div className="mobile-menu-content">
                            {children}

                            <button
                                className="mobile-login-button"
                                onClick={() => {
                                    handleLogin();
                                    closeMenu();
                                }}
                            >
                                Se connecter
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default MobileNavigation;